import React, { useState } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCashRegister } from "@fortawesome/free-solid-svg-icons";
import { getTotalCobradoAsync } from "../../../api/Dashboard";
import { useDatoPanel } from "../useDatoPanel";
import KpiPanel from "./KpiPanel";

const RecuperacionDiaria = () => {
  const [totalCobrado, setTotalCobrado] = useState(0);
  const { cargando, error, recargar } = useDatoPanel(
    getTotalCobradoAsync,
    (data) => setTotalCobrado(data.result ?? 0)
  );

  // Antes llevaba a /clients. El total es el cobrado hoy: lleva al reporte de recuperación de
  // hoy, de todos los gestores ("t"), con los mismos parámetros que arma su selector. El
  // permiso es el que usa la pantalla de Reportes para mostrar ese reporte.
  const hoy = moment().format("YYYY-MM-DD");

  return (
    <KpiPanel
      titulo="Recuperación Diaria"
      valor={totalCobrado}
      formato="monto"
      icono={<FontAwesomeIcon icon={faCashRegister} style={{ fontSize: 22 }} />}
      tono="success"
      cargando={cargando}
      error={error}
      onReintentar={recargar}
      destino={`/r-recuperacion/t/${hoy}/${hoy}`}
      permiso="RECUPERAC"
      ayuda="Ver el reporte de Recuperación de hoy"
    />
  );
};

export default RecuperacionDiaria;
